import createViewContext from '@util/create-view-context';

const {
  connectViewData,
  ViewContext,
  withViewDataProvider,
} = createViewContext();
export { connectViewData, ViewContext, withViewDataProvider };
